import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils"

const styles = theme => ({

  questionContainer: {
    width: '350px',
    border: '5px solid #003E4C',
    padding: '30px 10px 30px 30px',
    margin: '100px 10px 0px 40px',
    backgroundColor: '#fff',
    [emulatorScreen(theme)]: {
      width: '210px',
      border: '4px solid #003E4C',
      padding: '20px 10px 20px 20px',
      margin: '70px 38px 0px 25px',
    },
    [mobileScreen(theme)]: {
      width: "183px",
      border: "4px solid #003E4C",
      margin: "30px 38px 0px 62px",
      padding: "15px 13px 16px 16px"
    }
  },

  questionBody: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },

  breakingNews: {
    position: 'absolute',
    top: '-60px',
    left: '-80px',
    height: '60px',
    [emulatorScreen(theme)]: {
      top: '-40px',
      left: '-50px',
      height: '36px',
    },
    [mobileScreen(theme)]: {
      top: "-35px",
      left: "-43px",
      height: "31px"
    }
  },

  circleIcon: {
    position: 'absolute',
    top: '-115px',
    right: '-85px',
    height: '140px',
    [emulatorScreen(theme)]: {
      top: '-66px',
      right: '-52px',
      height: '85px',
    },
    [mobileScreen(theme)]: {
      top: "-55px",
      right: "-49px",
      height: "75px",
    }
  },

  questionText: {
    color: '#565656',
    fontWeight: "400",
    paddingTop: "12px",
    fontSize: '27px',
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: '16px',
    },
    [mobileScreen(theme)]: {
      fontSize: '12px',
      paddingTop: "8px",
    },
  },

  subQuestionText: {
    color: '#00b1d9',
    fontWeight: "400",
    paddingTop: "12px",
    fontSize: '27px',
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: '12px',
    },
    [mobileScreen(theme)]: {
      fontSize: '12px',
      paddingTop: "8px",
    },
  },


  optionQuestionContainer: {
    width: "400px",
    // border: "5px solid #003E4C",
    // padding: "0px 0px 30px 0px",
    margin: "20px",
    [emulatorScreen(theme)]: {
      width: "250px",
      // border: "5px solid #003E4C",
      padding: "0px 0px 30px 0px",
      margin: "75px 0px 0px 35px",
    },
    [mobileScreen(theme)]: {
      width: "220px",
      // border: "4px solid #003E4C",
      margin: "10px 35px 0px 0px",
      padding: "0px 0px 5px 0px",
    },
  },

  optionQuestion: {
    textAlign: "center",
    color: "#003E4C",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "'Oswald', sans-serif",
    lineHeight: 1.2,
    paddingLeft: 30,
    [emulatorScreen(theme)]: {
      fontSize: 12,
      lineHeight: 1.1,
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      lineHeight: 1.1,
    },
  },

  optionChoices: {
    border: "3px solid #003E4C",
    borderRadius: 10,
    fontWeight: 600,
    padding: "5px 0px",
    textAlign: "center",
    fontFamily: "'Oswald', sans-serif",
    fontSize: 20,
    cursor: "pointer",
    [emulatorScreen(theme)]: {
      padding: "4px 0px",
      fontSize: 13,
    },
    [mobileScreen(theme)]: {
      padding: "2px 0px",
      fontSize: 11,
    },
  },
  optionQuestionBody: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    height: 170,
    paddingLeft: 30,
    // paddingTop: 20,
    [emulatorScreen(theme)]: {
      paddingLeft: 17,
      height: 176,
      paddingTop: 16,
    },
    [mobileScreen(theme)]: {
      paddingLeft: 50,
      height: 110 ,
      paddingTop: 0,
    },
  },

})
export default styles;
